export const WHITELISTABLE_FEATURES_CONFIG = {
  dfs_conversation_sharing: {
    description: "Rely on DFS for conversation grants",
    stage: "dust_only",
    owner: "aubin-tchoi",
  },
  dfs_gcs_replication: {
    description:
      "Replicate this workspace's GCS pod and conversation files into DFS",
    stage: "dust_only",
    owner: "flvndvd",
  },
  dust_lean_agent: {
    description:
      "Enable @dust-lean, a Dust agent that starts without tools, skills, or company knowledge",
    stage: "ask_owner",
    owner: "aubin-tchoi",
  },
  stateful_conversation_window: {
    description:
      "Restore agent-loop context windows from the previous model step checkpoint",
    stage: "dust_only",
    owner: "flvndvd",
  },
  inference_hooks: {
    description:
      "Evaluate model inputs and outputs with workspace inference hooks",
    stage: "dust_only",
    owner: "frankaloia",
  },
  group_seat_provisioning: {
    description:
      "Map workspace groups to seat types so group membership drives members' seats",
    stage: "ask_owner",
    owner: "tdraier",
  },
  group_limits: {
    description: "Enable group shared usage limits on the Usage page",
    stage: "ask_owner",
    owner: "rfrenoy",
  },
  frames_v2_functions: {
    description:
      "Let Frames v2 declare server functions, databases and persistent files",
    stage: "ask_owner",
    owner: "davidebbo",
  },
  frames_v2_drafts: {
    description:
      "Let agents publish Frames v2 changes as drafts that go live only when made live",
    stage: "ask_owner",
    owner: "davidebbo",
  },
  frames_v2_public_functions: {
    description:
      "Let Frames v2 declare public functions that anonymous visitors of a public share can call (requires frames_v2_functions)",
    stage: "dust_only",
    owner: "achilleburah",
  },
  frames_v2_schedules: {
    description:
      "Let Frames v2 declare schedules on durable functions (requires frames_v2_functions)",
    stage: "dust_only",
    owner: "smb2268",
  },
  advanced_notion_management: {
    description:
      "Advanced features for Notion workspace management shown to admins",
    stage: "self_serve",
    owner: "fontanierh",
  },
  anthropic_vertex_fallback: {
    description: "Fallback to Vertex Anthropic for some Anthropic models",
    stage: "dust_only",
    owner: "flvndvd",
  },
  openai_flex_processing: {
    description:
      "Run trigger and wake-up agent runs on OpenAI flex processing (cheaper, slower), falling back to standard processing when flex does not deliver",
    stage: "dust_only",
    owner: "Nils-Fedrigo",
  },
  use_vertex_for_supported_models: {
    description:
      "Route LLM calls through Vertex AI when supported instead of the direct provider's API",
    stage: "dust_only",
    owner: "pmilliotte",
  },
  audit_logs: {
    description: "Enable audit log emission via WorkOS",
    stage: "self_serve",
    owner: "smb2268",
  },
  custom_model_feature: {
    description: "Access to custom models loaded from external config",
    stage: "dust_only",
    owner: "flvndvd",
  },
  dust_internal_global_agents: {
    description:
      "Access to internal global agents (dust-edge, dust-quick, dust-oai, dust-goog, custom model agents and their variants)",
    stage: "dust_only",
    owner: "fontanierh",
  },
  gpt_5_6_terra_long_context: {
    description: "Access to GPT 5.6 Terra with its full context window",
    stage: "self_serve",
    owner: "fontanierh",
  },
  disable_gpt_6_astra: {
    description:
      "Remove access to the GPT 6 Astra model: it is hidden from the model picker and rejected at message time, whatever the workspace plan and other flags",
    stage: "self_serve",
    owner: "Nils-Fedrigo",
  },
  dust_agent_sonnet_5_default: {
    description: "Use Claude Sonnet 5 as the default model for the @dust agent",
    stage: "dust_only",
    owner: "pmilliotte",
  },
  notion_private_integration: {
    description: "Setup Notion private integration tokens",
    stage: "ask_owner",
    owner: "fontanierh",
  },
  claude_4_opus_feature: {
    description: "Access to Claude 4 Opus model in the agent builder",
    stage: "self_serve",
    owner: "fontanierh",
  },
  premium_model_access: {
    description:
      "Access to premium models (Claude Opus, GPT Sol, GPT Astra) on workspaces without a credit-priced plan or advanced model access. Hands out paid-tier models for free, so it is an entitlement override, not a preview toggle.",
    stage: "ask_owner",
    owner: "pmilliotte",
  },
  claude_fable_5_feature: {
    description:
      "Access to Claude Fable family of models (served through the EAP Anthropic key)",
    stage: "dust_only",
    owner: "fontanierh",
  },
  deepseek_feature: {
    description:
      "Access to DeepSeek models (they cannot use tool so can't be selected in the agent builder)",
    stage: "self_serve",
    owner: "fontanierh",
  },
  exa_people_and_company: {
    description: "Access to Exa MCP server (search_people, search_companies)",
    stage: "dust_only",
    owner: "spolu",
  },
  disable_run_logs: {
    description: "Disable logging of agent runs",
    stage: "dust_only",
    owner: "spolu",
  },
  google_sheets_tool: {
    description: "Google Sheets MCP tool",
    stage: "ask_owner",
    owner: "frankaloia",
  },
  http_client_tool: {
    description: "HTTP Client MCP tool for making external API requests",
    stage: "self_serve",
    owner: "frankaloia",
  },
  index_private_slack_channel: {
    description: "Allow indexing of private Slack channels",
    stage: "self_serve",
    owner: "spolu",
  },
  openai_o1_feature: {
    description: "Access to OpenAI o1 model",
    stage: "self_serve",
    owner: "fontanierh",
  },
  openai_concise_reasoning_summaries: {
    description:
      "Use concise reasoning summaries for supported OpenAI models in the new LLM router",
    stage: "dust_only",
    owner: "fontanierh",
  },
  salesforce_synced_queries: {
    description: "Salesforce Connection: retrieval on Synchronized queries",
    stage: "ask_owner",
    owner: "PopDaph",
  },
  self_created_slack_app_connector_rollout: {
    description:
      "Slack Connection: rollout for self-created Slack app connector",
    stage: "ask_owner",
    owner: "fabiencelier",
  },
  salesforce_tool: {
    description:
      "Salesforce MCP tool (activated by default on most plans, FF to override the plan config)",
    stage: "self_serve",
    owner: "PopDaph",
  },
  show_debug_tools: {
    description: "Display debug tools in the interface",
    stage: "dust_only",
    owner: "spolu",
  },
  usage_data_api: {
    description:
      "API for accessing usage data (Means that any builder with an API key can access usage data of the workspace from API)",
    stage: "self_serve",
    owner: "flvndvd",
  },
  noop_model_feature: {
    description: "Access to noop model in the agent builder",
    stage: "dust_only",
    owner: "davidebbo",
  },
  simulated_failure_model_feature: {
    description: "Access to the simulated failure model",
    stage: "dust_only",
    owner: "frankaloia",
  },
  standard_stream_gpt_6_luna_high: {
    description:
      "Route the Standard model tier to GPT 6 Luna at high reasoning first, to test it as the Standard baseline",
    stage: "dust_only",
    owner: "Nils-Fedrigo",
  },
  automatic_model_health_routing: {
    description:
      "Let a model-health breach seen on this workspace's traffic degrade the endpoint",
    stage: "dust_only",
    owner: "frankaloia",
  },
  slack_message_splitting: {
    description:
      "Enable splitting agent responses into multiple Slack messages for Slack (instead of truncation)",
    stage: "self_serve",
    owner: "frankaloia",
  },
  legacy_dust_apps: {
    description: "Access to legacy Dust Apps (editor and associated tools)",
    stage: "self_serve",
    owner: "spolu",
  },
  power_bi_mcp: {
    description: "Power BI MCP tool for querying semantic models and DAX",
    stage: "self_serve",
    owner: "LeandreLeBizec",
  },
  netsuite_mcp: {
    description:
      "NetSuite MCP tool for querying records and interacting with your NetSuite account",
    stage: "self_serve",
    owner: "LeandreLeBizec",
  },
  figma_mcp: {
    description:
      "Offer the Figma MCP to a workspace that is not on a credit-based plan",
    stage: "ask_owner",
    owner: "smb2268",
  },
  dust_internal_dangerous_in_cluster_mcp_servers: {
    description:
      "EXPERIMENTAL FEATURE. DUST INTERNAL ONLY. Allow remote MCP servers pointing at hosts on the MCP_IN_CLUSTER_HOSTS allowlist, reached in-cluster instead of through the untrusted egress proxy.",
    stage: "dust_only",
    owner: "id13",
  },
  agent_stream_long_polling: {
    description:
      "Start agent event streams with long polling for this workspace",
    stage: "self_serve",
    owner: "id13",
  },
  shopify_tool: {
    description: "Shopify MCP tool",
    stage: "self_serve",
    owner: "spolu",
  },
  run_tools_from_prompt: {
    description: "Enable /run command to directly call tools without LLM",
    stage: "dust_only",
    owner: "davidebbo",
  },
  conversations_slack_notifications: {
    description: "Enable slack notifications",
    stage: "ask_owner",
    owner: "matteotrab",
  },
  reinforced_agents: {
    description:
      "Enable self-improvement (background analysis of conversations to suggest improvements to skills).",
    stage: "self_serve",
    owner: "davidebbo",
  },
  self_improvement_beta_tester: {
    description:
      "Self-improvement runs for free: consumption is not reported to billing (Metronome or programmatic usage).",
    stage: "self_serve",
    owner: "fabiencelier",
  },
  conversation_consumption_details: {
    description:
      "Show the detailed credit attribution for agent messages in conversations",
    stage: "dust_only",
    owner: "flvndvd",
  },
  poke_mcp: {
    description: "Enable the Poke MCP server for cross-workspace data access.",
    stage: "dust_only",
    owner: "aubin-tchoi",
  },
  legacy_billing: {
    description:
      "Force this workspace to use legacy Stripe billing, bypassing Metronome credit-priced plans regardless of the global kill switch.",
    stage: "self_serve",
    owner: "tdraier",
  },
  plan_mode: {
    description:
      "Enable the Plan Mode skill: agents maintain a live plan.md for genuinely multi-step tasks, with an optional human-approval checkpoint.",
    stage: "self_serve",
    owner: "PopDaph",
  },
  admin_can_see_private_entities: {
    description:
      "Let workspace admins see the content (instructions, tools, knowledge, files) of the agents and skills they cannot read, instead of a redacted view",
    stage: "ask_owner",
    owner: "fabiencelier",
  },
  allow_old_notion_mcp: {
    description:
      "Allow individual workspaces to keep using the old internal Notion MCP server alongside the official one",
    stage: "self_serve",
    owner: "davidebbo",
  },
  dummy_feature_for_flag_testing: {
    description: "Dummy feature flag used for testing feature flag behavior",
    stage: "dust_only",
    owner: "davidebbo",
  },
  sensitivity_labels: {
    description:
      "Enable Microsoft sensitivity labels for data classification on connectors and MCP servers",
    stage: "self_serve",
    owner: "tdraier",
  },
  remote_db_query_identity_labels: {
    description:
      "Attach Dust workspace/agent/user sIds as BigQuery job labels and Snowflake QUERY_TAG for remote database cost attribution",
    stage: "self_serve",
    owner: "fraggle",
  },
  restricted_spaces_in_input_bar: {
    description:
      "Allow users to explicitly select Spaces from the conversation input bar.",
    stage: "dust_only",
    owner: "fontanierh",
  },
  disable_formatting_prompt: {
    description:
      "Skip injecting the OpenAI formatting meta prompt entirely (no markdown/paragraph style guidance)",
    stage: "dust_only",
    owner: "fontanierh",
  },
  workspace_default_agent: {
    description:
      "Workspace default agent: admins can pre-select a workspace-wide default agent for new conversations.",
    stage: "self_serve",
    owner: "davidebbo",
  },
  whitelabel_frames: {
    description:
      "Whitelabel frames: customize the workspace logo, favicon and OG image shown on shared Frames.",
    stage: "self_serve",
    owner: "flvndvd",
  },
  activation_force_nudge: {
    description:
      "Bypass the activated-user check in the activation orchestrator so already-activated users are still nudged",
    stage: "dust_only",
    owner: "frankaloia",
  },
  dust_pod_goal: {
    description:
      "Enable the Dust Pod Goal skill for persistent job loops in Pods",
    stage: "dust_only",
    owner: "frankaloia",
  },
  dust_file_system: {
    description:
      "Mirror Pods and their permissions in the Dust File System (dfs): each Pod gets a folder whose grants follow the Pod's access",
    stage: "dust_only",
    owner: "fabiencelier",
  },
  user_memory: {
    description:
      "Enable the user_memory internal MCP server: agents can store and retrieve per-user memory in a user-scoped filesystem.",
    stage: "dust_only",
    owner: "PopDaph",
  },
  similar_agents_check: {
    description:
      "Warn users about similar existing agents before they create a duplicate in the agent builder.",
    stage: "self_serve",
    owner: "avervaet",
  },
  enforce_premium_model_message_limit: {
    description:
      "Enforce the premium-model cap: once the user has spent 25 premium-tier messages in the rolling week, run the message on the Standard stream instead, on workspaces with a non-credit-priced (legacy) plan. Usage is counted regardless, so the flag only controls enforcement.",
    stage: "dust_only",
    owner: "id13",
  },
  editable_tool_inputs: {
    description:
      "Allow editing tool inputs before approving a tool call in the tool validation UI.",
    stage: "dust_only",
    owner: "matteotrab",
  },
  skip_free_usage_rate_limit: {
    description:
      "Skip the per-user daily free-usage cost cap enforced at the LLM call site. Escape hatch to unstick legitimate workspaces that legitimately exceed the free-usage limit.",
    stage: "self_serve",
    owner: "fabiencelier",
  },
  disable_fair_use_awu_limit: {
    description:
      "Disable the per-user fair-use AWU credit limit on this workspace: skip both the pre-message enforcement (read) and the usage recording (write). Escape hatch for workspaces that should not be subject to the fair-use cap.",
    stage: "self_serve",
    owner: "tdraier",
  },
  fixed_window_fair_use: {
    description:
      "Enforce the per-user fair-use AWU credit limit over a fixed UTC calendar window matching the plan timeframe (day, ISO week Monday→Monday, or calendar month) instead of the default rolling window. The counter resets at each window boundary rather than sliding continuously.",
    stage: "self_serve",
    owner: "tdraier",
  },
  archive_inactive_agents: {
    description:
      "Allow this workspace to preview and archive agents that have not been mentioned for a configurable number of days.",
    stage: "self_serve",
    owner: "achilleburah",
  },
  legacy_trigger_limits: {
    description:
      "Keep the legacy trigger limits: automations may still be charged to personal credits on a non credit-priced plan.",
    stage: "self_serve",
    owner: "adrsimon",
  },
  message_export_from_consumption_index: {
    description:
      "Use the consumption analytics ES index instead of the message analytics index for message exports.",
    stage: "ask_owner",
    owner: "sfriquet",
  },
  agent_message_consumption_writes: {
    description:
      "Write agent-message consumption items and outbox events as usage is incurred. Shadow mode keeps existing billing.",
    stage: "dust_only",
    owner: "id13",
  },
  agent_message_consumption_bills: {
    description:
      "Use agent-message consumption items for Metronome, costCredits, and usage counters. Requires agent_message_consumption_writes.",
    stage: "dust_only",
    owner: "id13",
  },
  discovery_homepage: {
    description: "New homepage optimized for skill and agents discovery",
    stage: "self_serve",
    owner: "adrsimon",
  },
  co_edition: {
    description: "Collaborative editing features",
    stage: "dust_only",
    owner: "PopDaph",
  },
  self_configuration_tool: {
    description:
      "Let @dust raise its own reasoning effort mid-conversation on Claude models that support per-message effort",
    stage: "dust_only",
    owner: "aubin-tchoi",
  },
} as const satisfies Record<string, FeatureFlag>;

export type FeatureFlagStage = "dust_only" | "ask_owner" | "self_serve";

export const FEATURE_FLAG_STAGE_LABELS: Record<FeatureFlagStage, string> = {
  dust_only: "Dust-only",
  ask_owner: "Ask owner",
  self_serve: "Self-serve",
};

export const FEATURE_FLAG_STAGE_DESCRIPTIONS: Record<FeatureFlagStage, string> =
  {
    dust_only:
      "Cannot be activated outside Dust workspaces, the feature is not ready.",
    ask_owner: "Ask the eng owner before activating.",
    self_serve:
      "Safe to activate if you understand the feature and its impact on the workspace.",
  };

export const FEATURE_FLAG_STAGES = [
  "dust_only",
  "ask_owner",
  "self_serve",
] as const satisfies readonly FeatureFlagStage[];

export type FeatureFlag = {
  description: string;
  stage: FeatureFlagStage;
  // GitHub handle of the eng owner of the feature.
  owner: string;
};

export type WhitelistableFeature = keyof typeof WHITELISTABLE_FEATURES_CONFIG;

export const WHITELISTABLE_FEATURES = Object.keys(
  WHITELISTABLE_FEATURES_CONFIG
) as WhitelistableFeature[];

const FRAMES_V2_FUNCTIONS_FEATURE =
  "frames_v2_functions" as const satisfies WhitelistableFeature;
const FRAMES_V2_DRAFTS_FEATURE =
  "frames_v2_drafts" as const satisfies WhitelistableFeature;
const FRAMES_V2_PUBLIC_FUNCTIONS_FEATURE =
  "frames_v2_public_functions" as const satisfies WhitelistableFeature;
const FRAMES_V2_SCHEDULES_FEATURE =
  "frames_v2_schedules" as const satisfies WhitelistableFeature;

export function isFramesV2FunctionsEnabled(
  featureFlags: WhitelistableFeature[]
): boolean {
  return featureFlags.includes(FRAMES_V2_FUNCTIONS_FEATURE);
}

export function isFramesV2DraftsEnabled(
  featureFlags: WhitelistableFeature[]
): boolean {
  return featureFlags.includes(FRAMES_V2_DRAFTS_FEATURE);
}

/**
 * @cc [owner:achilleburah,label:product;security] frames-v2-public-functions-requires-frames-v2-functions
 * Public Frame functions MUST be reported enabled only when Frame functions are enabled (see
 * isFramesV2FunctionsEnabled) and frames_v2_public_functions is on.
 */
export function isFramesV2PublicFunctionsEnabled(
  featureFlags: WhitelistableFeature[]
): boolean {
  return (
    isFramesV2FunctionsEnabled(featureFlags) &&
    featureFlags.includes(FRAMES_V2_PUBLIC_FUNCTIONS_FEATURE)
  );
}

/**
 * @cc [owner:smb2268,label:product] frames-v2-schedules-requires-frames-v2-functions
 * Frame schedules MUST be reported enabled only when Frame functions are enabled (see
 * isFramesV2FunctionsEnabled) and frames_v2_schedules is on.
 */
export function isFramesV2SchedulesEnabled(
  featureFlags: WhitelistableFeature[]
): boolean {
  return (
    isFramesV2FunctionsEnabled(featureFlags) &&
    featureFlags.includes(FRAMES_V2_SCHEDULES_FEATURE)
  );
}

export function isWhitelistableFeature(
  feature: unknown
): feature is WhitelistableFeature {
  return WHITELISTABLE_FEATURES.includes(feature as WhitelistableFeature);
}
